import { getLanguageText } from '../utils/locale.js';
import i18n from '@/i18n';

export function getStreetName({ building, street }, language = i18n.locale) {
  // let buildingName = '';
  // if (building.buildingName) {
  //   buildingName += building.buildingName;
  //   buildingName += '/';
  // }
  // return `${buildingName}${street.streetName}`;
  let streetNameCn = getLanguageText(street, 'streetName', 'cn');
  let streetNamePt = getLanguageText(street, 'streetName', 'pt');
  let buildingNameCn = getLanguageText(
        building,
        'buildingName',
        'cn'
      );
  let buildingNamePt = getLanguageText(
        building,
        'buildingName',
        'pt'
      );
  return language === 'zh-Hant' ? `${buildingNameCn}/${streetNameCn}` : `${buildingNamePt}/${streetNamePt}`;
}
